import api from '@/apis/di/typeOfFundAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid CTMT
export const useTypeOfFundComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();
  // func call api lấy dữ liệu combo
  const onTypeOfFundComboboxLoadData = (payload, row, column, custom) => {
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
    payload.filter = extendFilter(payload.filter, extend);
    payload.sort = 'fund_code';
    payload.columns += ',fund_id';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, custom?.callBackFn);
  };

  // config columns combo
  const typeOfFundComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã loại quỹ',
        dataField: 'fund_code',
        width: 100,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên loại quỹ',
        dataField: 'fund_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 500,
      },
    ],
    displayField: 'fund_code',
    valueField: 'fund_id',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onTypeOfFundComboboxLoadData,
  };

  return {
    typeOfFundComboConfig,
    onTypeOfFundComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
